import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const StudentPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const token = new URLSearchParams(window.location.search).get("token");

  // 👇 Generates new session per day
  const generateDailySessionId = () => {
    const today = new Date().toISOString().split("T")[0];
    const sessionKey = `session_id_${today}`;
    let sessionId = localStorage.getItem(sessionKey);

    if (!sessionId) {
      sessionId = `${Math.random().toString(36).slice(2)}-${Date.now()}`;
      localStorage.setItem(sessionKey, sessionId);
    }

    return sessionId;
  };

  useEffect(() => {
    if (!token) {
      setError("Invalid or missing token");
      return;
    }

    const sessionId = generateDailySessionId();
    const existingStudentId = localStorage.getItem("student_id");

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/attendance/scan`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token,
        student_id: existingStudentId,
        session_id: sessionId,
      }),
    })
      .then(async (res) => {
        const data = await res.json();

        if (data.already_marked && data.student_id && data.student_name) {
          // ✅ Recognized repeat scan — go to confirmation
          localStorage.setItem("student_id", data.student_id);
          localStorage.setItem("student_name", data.student_name);
          navigate("/ConfirmationPage");
        } else if (res.ok && data.student_id && data.student_name) {
          // ✅ First-time attendance success
          localStorage.setItem("student_id", data.student_id);
          localStorage.setItem("student_name", data.student_name);
          navigate("/ConfirmationPage");
        } else if (data.requires_registration) {
          // 📝 First-time visitor, show form
        } else {
          setError(data.error || "Unknown error");
        }
      })

      .catch((err) => {
        console.error(err);
        setError("Something went wrong while validating token.");
      });
  }, [token, navigate]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    const sessionId = generateDailySessionId();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/attendance/scan`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token,
            name,
            email,
            phone,
            session_id: sessionId,
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.student_id && data.student_name) {
        localStorage.setItem("student_id", data.student_id);
        localStorage.setItem("student_name", data.student_name);
        navigate("/ConfirmationPage");
      } else {
        setError(data.error || "Registration failed");
      }
    } catch (err) {
      console.error(err);
      setError("An unexpected error occurred.");
    }
  };

  return (
    <div className="welcome_page">
      <div className="sidebar">
        <img
          src="student_avatar.png"
          alt="Student Sidebar Avatar"
          className="sidebar_avatar"
        />
        <img
          src="church_logo_no_bg.png"
          alt="Church Logo"
          className="church_logo"
        />
      </div>
      <div className="media_query_banner_container">
        <div className="media_query_banner">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </div>

      <div className="form_side">
        <div className="student_main">
          <div className="student_head">
            <h1>Welcome to Life Discussion</h1>
            <p>
              Fill this form once to register. We’ll mark you present — and you
              can ask a question too!
            </p>
          </div>
          <div className="form_body">
            <form onSubmit={handleRegister}>
              <div className="student_form">
                <label htmlFor="name">FULL NAME</label>
                <input
                  type="text"
                  id="name"
                  placeholder="John Doe"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="student_form">
                <label htmlFor="email">EMAIL ADDRESS</label>
                <input
                  type="email"
                  id="email"
                  placeholder="johndoe@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="student_form">
                <label htmlFor="phone">PHONE NUMBER</label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="+44 0000 000000"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>
              {error && (
                <p style={{ color: "red", fontSize: "small" }}>{error}</p>
              )}
              <button className="student_login_btn" type="submit">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentPage;
